import React from 'react';
import Image from '@sls-react/components/Image';
import ArrowRightIcon from '@sls-react/static/svg/ArrowRightIcon';
import classNames from 'classnames';

interface Props {
  className?: any;
  image?: string;
  onClick?: React.MouseEventHandler;
  title: string;
}

const HorizontalOnlyUnlimitedTile: React.FC<Props> = ({
  className,
  image,
  onClick,
  title,
}) => (
  <button
    className={classNames(
      'p-2 border bg-white rounded shadow flex w-full items-center px-4 border-grey-200 hover:shadow-md transition-shadow duration-300',
      className,
    )}
    onClick={onClick}
  >
    {image ? (
      <span className="relative w-8 h-8 ml-0 mr-4">
        <Image
          alt=""
          src={image}
          className="block object-cover w-8 h-8 rounded"
          useFastly={{
            height: 80,
            width: 80,
            optimize: 'medium',
          }}
        />
      </span>
    ) : (
      <div className="w-8 h-8 ml-0 mr-4" />
    )}

    <div className="block mt-0 text-sm font-semibold text-left">{title}</div>

    <div className="mr-auto" />

    <ArrowRightIcon className="block" />
  </button>
);

export default HorizontalOnlyUnlimitedTile;
